<template>
  <div
       :class="['checkbox', 'tip', generateCheckboxClass(field)]"
       :data-original-title="field.help"
       data-placement="bottom"
       data-toggle="tooltip">
      <switcher v-model="current_value" :as_number="as_number"></switcher>
  </div>
</template>

<script>
import Switcher from "./SubElements/Switcher"
export default {
  name:"CustomSwitch",
  props:["field", "value","field_idx", "as_number"],
  components:{
    Switcher,
  },
  data(){
    return {
      current_value:this.value
    }
  },

  mounted() {
    if (this.current_value === null) {
      this.current_value = false
    }
  },

  methods:{
    generateCheckboxClass (field) {
      return [
        (field.required) ? "checkbox-danger" : "checkbox-primary"
      ]
    },
  },

  watch:{
    current_value : function (newv, oldv)  {
      this.$emit("field-updated", {type:this.field.type, idx:this.field_idx, new_value:this.current_value})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// client/components/Forms/Elements/Switch.vue